import { Popover } from 'antd';
import styled from 'styled-components';

export default styled(Popover)`
	// Add your styles here
`;
